import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { useRequestData, usePrefs } from 'wsm-common-data';
import { trackEvent } from '../utilities/tracking';
import { getPlacement } from '../utilities/aspect';

const CtaButton = ({
	carouselPosition,
	customAsset = false,
	ctaButtonClasses = [],
	isVisible = true,
	label,
	url,
	promo
}) => {
	let button = null;
	const { widgetName, windowId } = useRequestData();
	const { aspectRatio } = usePrefs();
	const personalized = useSelector((state) => state.personalized);

	const onClick = () => {
		trackEvent({
			widgetName,
			windowId,
			event: 'specialsEvent',
			specialType: 'click',
			specialCategory:
				promo.type.charAt(0) + promo.type.slice(1).toLowerCase(),
			specialId: promo.id,
			specialPlacementType: getPlacement(aspectRatio),
			specialPersonalized: personalized,
			specialAutoGen: promo.autoGenerated,
			nonInteractive: false,
			carouselPosition,
			customAsset
		});
	};

	// Only display the button if we have an href and label
	if (url && url !== 'default' && label && label !== 'default') {
		// Set tabindex='-1' to hide offscreen Button from tabbing for A11Y
		// TODO: Need data-promo-tracking... attributes
		button = (
			<Button
				role="button"
				className={ctaButtonClasses}
				onClick={() => {
					onClick();
				}}
				bsStyle="primary"
				bsSize="lg"
				href={url}
				target={promo?.ctaConfig?.openInNewTab ? '_blank' : '_self'}
				tabIndex={isVisible ? null : '-1'}
			>
				{label}
				<p className='sr-only'>{promo?.ctaConfig?.openInNewTab ? 'open in new tab' : 'open in same tab'}</p>
			</Button>
		);
	}
	return button;
};

CtaButton.propTypes = {
	clickEvent: PropTypes.func,
	classes: PropTypes.arrayOf(PropTypes.string),
	isVisible: PropTypes.bool,
	label: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
	promo: PropTypes.shape({}).isRequired
};

export default CtaButton;
